module.exports = __webpack_public_path__ + "static/media/imgGenres.359e7b56.png";